<svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect [attr.stroke]="fillColor" x="1" y="1" width="8" height="14" rx="2" fill="white" stroke-width="2" />
  <rect [attr.fill]="fillColor" x="0.666504" y="11.3333" width="8.66667" height="4" />
  <circle cx="5" cy="13.6667" r="1" fill="white" />
</svg>
